import { DateTime } from 'luxon';
import { PaginationRequest } from '../pagination/pagination';

export type ReviewsOrder = {
  readonly id: number;
  readonly orderNumber: string;
};

export type ReviewsUser = {
  readonly id: number;
  readonly name: string;
  readonly email: string;
};

export enum ReviewStatus {
  Pending = 'Pending',
  Completed = 'Completed',
}

export enum ReviewFeedback {
  Negative = 'Negative',
  Positive = 'Positive',
}

export type OrderReview = {
  readonly id: number;
  readonly user: ReviewsUser;
  readonly order: ReviewsOrder;
  readonly rating?: ReviewFeedback;
  readonly createdAt: DateTime;
  readonly reviewedOn?: DateTime;
  readonly status: ReviewStatus;
};

export class OrderReviewSearchRequest {
  keyword?: string;
  statusFilter?: ReviewStatus;
  reviewedAfter?: DateTime;
  reviewedBefore?: DateTime;
}

export type OrderReviewStatistics = {
  readonly totalReviews: number;
  readonly totalPending: number;
  readonly totalLiked: number;
  readonly totalDisliked: number;
};

export type OrderReviewSearchPaginationRequest = PaginationRequest & OrderReviewSearchRequest;
